export const SEARCH_FORMAT_DATE = 'MM/dd/yyyy';
export const SERVER_FORMAT_DATE = 'yyyy-MM-dd';
export const MONTH_FORMAT_DATE = 'MMMM-yyyy';
export const CART_FORMAT_DATE = 'MMMM do, yyyy';
export const CART_FORMAT_DATE_WITH_WEEK = 'EEEE, MMMM do, yyyy';
export const DAILY_DATE_FORMAT = 'dd MMM yyyy';
export const SCHEDULE_DATE_FORMAT = 'MMM, dd';
export const OVERNIGHTS_DATE_FORMAT = 'MMMM do';
export const SEARCH_FORMAT = 'EEE MMM do, yyyy';
